import React from "react";
import Image from "next/image";
import { useMediaQuery } from "react-responsive";
import { Container, Grid, Typography } from "@pmberjaya/cloudbank-ui";
const contentFooter = [
  {
    title: "Tentang Cloudbank",
    nav: [
      {
        name: "Teknologi Kami",
        link: `${process.env.REACT_APP_DOMAIN}technology`,
      },
      {
        name: "Hubungi Kami",
        link: `${process.env.REACT_APP_NEW_DOMAIN}contact`,
      },
      {
        name: "Pertanyaan Yang Sering Dipertanyakan",
        link: "https://kb.cloudbank.id/docs/",
      },
      {
        name: "Bergabung Kemitraan",
        link: `${process.env.REACT_APP_DOMAIN}reseller`,
      },
    ],
  },
  {
    title: "Sumber",
    nav: [
      {
        name: "syarat dan ketentuan",
        link: `${process.env.REACT_APP_DOMAIN}service-level-agreement`,
      },
      {
        name: "persyaratan Domain indonesia",
        link: `${process.env.REACT_APP_DOMAIN}persyaratan-domain-indonesia`,
      },
      {
        name: "blog",
        link: `https://blog.cloudbank.id/`,
      },
    ],
  },
  {
    title: "Sosial Media",
    nav: [
      {
        name: "instagram",
        link: "https://www.instagram.com/cloudbank.id/",
      },
    ],
  },
];

const FooterCloud = () => {
  const isMobile = useMediaQuery({ maxWidth: 600 });

  return (
    <footer>
      <div className={` d-none d-sm-block bg-primary`} id="testingFooter">
        <div className="container-fluid py-3">
          <Grid row>
            <Grid
              xs={12}
              sm={4}
              alignItems="center"
              justifyContent="center"
              alignSelf="center"
            >
              <Image
                src="/image/cloudbankWhite.png"
                width={305}
                height={136}
                alt="footer"
              />
            </Grid>
            {contentFooter.map((row, index) => (
              <Grid
                xs={12}
                mt={3}
                className={` text-light ${
                  index === 0 ? "col-sm-3 " : "col-sm-2"
                }`}
              >
                <h4 className="text-light text-uppercase fw-bold mb-3">{row.title}</h4>
                <ul className="list-unstyled">
                  {row.nav.map((items) => (
                    <li className="pointer text-capitalize">
                      <a onClick={() => window.open(items.link)}>
                        <h5 className="fw-light opacity-75">{items.name}</h5>
                      </a>
                    </li>
                  ))}
                </ul>
              </Grid>
            ))}
          </Grid>
        </div>
      </div>

      <div className={` d-block d-sm-none  mt-5	`} id="testingFooter">
        <Container>
          <Grid row>
            <Grid xs={12} sm={4} justifyContent="center" alignItems="center">
              <Image
                alt="footer logo cloudbank"
                src="/image/cloudbank.png"
                width={305}
                height={136}
              />
              {/* <img src="/image/cloudbank.png" width="70%"/> */}
            </Grid>
            {contentFooter.map((row, index) => (
              <Grid
                xs={12}
                mt={3}
                className={` ${index === 0 ? "col-sm-3 " : "col-sm-2"}`}
              >
                <h4 className="text-primary fw-bold mb-3">{row.title}</h4>
                <ul className="list-unstyled">
                  {row.nav.map((items) => (
                    <li className="text-left pointer fs-5 text-capitalize">
                      <a onClick={() => window.open(items.link)}>
                        <h5 className="mb-0">{items.name}</h5>
                      </a>
                    </li>
                  ))}
                </ul>
              </Grid>
            ))}
          </Grid>
        </Container>
      </div>
    </footer>
  );
};

export default FooterCloud;
